import { useState } from "react";
import isEqual from "lodash/isEqual";
import SortingMenu from "./SortingMenu";
import { SortingButtonProps } from "./types";

export default function SortingButton({
  visibleColumns,
  hiddenColumns,
  sorting,
  setSorting,
  columnsTitleCreator,
  initialSorting,
}: SortingButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  const hasChanged = !isEqual(sorting, initialSorting || []);

  return (
    <div>
      <SortingMenu
        open={isOpen}
        setOpen={setIsOpen}
        hasChanged={hasChanged}
        visibleColumns={visibleColumns}
        hiddenColumns={hiddenColumns}
        sorting={sorting}
        setSorting={setSorting}
        initialSorting={initialSorting}
        columnsTitleCreator={columnsTitleCreator}
        menuHeight="440px"
        menuWidth="655px"
        buttonTestId="table-toolbar-sorting-button"
      />
    </div>
  );
}
